
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.1 7.733a3.294 3.294 0 001.02-2.4C12.12 3.467 10.717 2 8.93 2H3.827c-.382 0-.638.267-.638.667v10.666c0 .4.256.667.638.667h5.741c1.786 0 3.19-1.467 3.19-3.333 0-1.267-.702-2.334-1.659-2.934zm-6.635-4.4H8.93c1.085 0 1.914.867 1.914 2 0 1.134-.83 2-1.914 2H4.465v-4zm0 9.334h5.103c1.085 0 1.914-.867 1.914-2 0-1.134-.83-2-1.914-2H4.465v4z","fill":"#000"}})])
          )
        }
      }
    